import { useState } from "react";
import { adminApi as api, extractErrorMessage } from "../../../../util/api";
import { camelizeKeys, snakifyKeys } from "../../../../util/helpers";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../../components/DetailedErrorAlert";
import { CustomerSuccessAutoAssignmentForm } from "./CustomerSuccessAutoAssignmentForm";
import { Form } from "react-final-form";

export const EditCustomerSuccessAutoAssignmentModal = ({ customerSuccessAutoAssignment, onUpdate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen((x) => !x);

  const handleUpdate = async (params) => {
    try {
      const res = await api.patch(`/admin/customer_success_auto_assignments/${params.id}`, snakifyKeys(params));

      if (onUpdate) {
        onUpdate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Edit
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Edit Customer Success Round Robin</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleUpdate} initialValues={{ ...customerSuccessAutoAssignment }}>
            {(props) => <CustomerSuccessAutoAssignmentForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
